export enum TableOption {
    R2TForced = 2050
}